const usePermissionConfig = () => {
  return {
    /*
    * 创建区域
    * 跳转路由名称：RegionalSettingList
    * */
    CREATE: 'OPS-XTPZ-QYSZ-CJQY',
    /*
    * 编辑区域
    * 跳转路由名称：RegionalSettingList
    * */
    EDIT: 'OPS-XTPZ-QYSZ-BJQY',
    /*
    * 操作日志
    * 跳转路由名称：RegionalSettingList
    * */
    VIEW_LOG: 'OPS-XTPZ-QYSZ-CZRZ',
  };
};

export default usePermissionConfig;
